__turbopack_context__.v({
  "app-message": "index-module-scss-module__5doFPa__app-message",
  "failure": "index-module-scss-module__5doFPa__failure",
  "show": "index-module-scss-module__5doFPa__show",
  "success": "index-module-scss-module__5doFPa__success",
});
